export const removeSpaces = (input) => {
  let _temp = input

  while (_temp.indexOf('  ') > -1) {
    _temp = _temp.replace('  ', ' ')
  }

  _temp = _temp.trim()

  return _temp
}

export const tryParseJSON = (s) => {
  try {
    const o = JSON.parse(s)

    if (o && typeof o === 'object') {
      return o
    }
  } catch (e) {
    return undefined
  }

  return undefined
}

export const analyticsAttrFormatter = (s) => {
  const res = {}

  const matches = s?.matchAll('{{data-[A-Za-z-]+=[^}}]+}}') || []

  for (const match of matches) {
    const dataMatch = match[0]

    const filteredMatch = dataMatch.replaceAll('{{', '').replaceAll('}}', '')

    const key = filteredMatch.split('=')[0]
    const val = filteredMatch.split('=')[1]

    res[key] = val
  }
  return res
}

export const parseDataTags = (s) => {
  let dataTags = {}

  if (s.length > 0) {
    const _tags = s.split('||')

    _tags.forEach((t) => {
      const tag = t.split('=')

      dataTags = { ...dataTags, ...{ [`data-${tag[0]}`]: tag[1] } }
    })
  }

  return dataTags
}

export const isBannerTypeOf = (bannerType, s) => {
  return bannerType && bannerType === s
}

export const formatDateMDY = (date) => {
  return new Date(date).toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
